export default "/images/capcha-mini.png?4f5d2f6c55ed8a7698f5e8bb0511ba94";